// @ts-nocheck

import { findIndex } from 'lodash';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const Wrap = styled.div``;

const Items = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0.6em 0;
`;

const Item = styled.button`
  && {
    background-color: transparent;
    border: none;
    width: ${({ $percentWidth }) => $percentWidth}%;
  }
`;

const WrapLine = styled.div`
  position: relative;
`;

const Line = styled.div`
  position: absolute;
  top: 2px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.grids.colors.lightgrey};
`;

const MovingRepere = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  transform: translate3d(${({ $translateX }) => $translateX}%, 0, 0);
  transition: transform 300ms ease-out;
`;

const WrapRepere = styled.div`
  width: ${({ $percentWidth }) => $percentWidth}%;
  height: 100%;
  text-align: center;
  position: relative;
`;

const Repere = styled.div`
  margin: 0 auto;
  background-color: ${({ theme }) => theme.grids.colors.redlight};
  width: 50%;
  height: 100%;
  border-radius: 4px;
`;

type MovingRepereMenuProps = {
  className?: string;
  items: Array<{
    id: string;
    label: string;
  }>;
  selectedId: string;
  onClick: (itemId: string) => void;
};

const MovingRepereMenu = ({ className, selectedId, items, onClick }: MovingRepereMenuProps) => {
  const percentWidthItem = useMemo(() => 100 / items.length, [items.length]);
  const selectedIndex = useMemo(() => findIndex(items, (item) => item.id === selectedId), [items, selectedId]);
  return (
    <Wrap className={className}>
      <Items>
        {items.map((item) => (
          <Item key={item.id} onClick={() => onClick(item.id)} $percentWidth={percentWidthItem}>
            {item.label}
          </Item>
        ))}
      </Items>
      <WrapLine>
        <Line />
        <MovingRepere $translateX={selectedIndex * percentWidthItem}>
          <WrapRepere $percentWidth={percentWidthItem}>
            <Repere />
          </WrapRepere>
        </MovingRepere>
      </WrapLine>
    </Wrap>
  );
};

export default MovingRepereMenu;
